import { Modal, Spin, DatePicker } from 'antd';
import { Formik } from 'formik';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { GetCustomerDashboard, ActionGetCCPaperDetail } from '../../store/Actions/PatientAction';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import * as Yup from 'yup';
import { PersonalDetail } from '../../store/Actions/personalDetails.actions';

const AnniversaryValidationSchema = Yup.object().shape({
    anniversaryDate: Yup.mixed()
        .required('Anniversary date is required')
        .test('is-valid-date', 'Invalid date', (value) =>
            value ? dayjs(value).isValid() : false
        )
        .nullable(),
});

const AnniversaryModel = ({ IsOpen = {}, Isclose, customerData = {}, confirmationDetails = {} }) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);

    return (
        <Modal
            open={IsOpen?.is}
            title="Update Anniversary Date"
            onCancel={Isclose}
            footer={null}
            centered
            styles={{
                mask: {
                    backdropFilter: 'blur(4px)',
                },
                content: {
                    borderRadius: '20px',
                },
            }}
        >
            <Formik
                initialValues={{
                    anniversaryDate: confirmationDetails?.anniversaryDate ? dayjs(confirmationDetails.anniversaryDate) : null,
                }}
                validationSchema={AnniversaryValidationSchema}
                onSubmit={(values, { setSubmitting }) => {
                    setIsLoading(true);

                    // Prepare payload - include existing confirmation details to avoid overwriting them
                    const payload = {
                        anniversaryDate: values.anniversaryDate ? values.anniversaryDate.format('YYYY-MM-DD') : null,
                    };

                    dispatch(
                        PersonalDetail(
                            {
                                customerId: IsOpen.id,
                                obj: JSON.stringify(payload),
                            }, (res) => {
                                setIsLoading(false);
                                setSubmitting(false);
                                if (res?.statusCode === 200 || res?.success) {
                                    // Refresh dashboard and CC paper details to reflect changes
                                    dispatch(GetCustomerDashboard({ Query: `/${IsOpen.id}` }));
                                    dispatch(ActionGetCCPaperDetail({ Query: `/${IsOpen.id}` }));
                                    Isclose();
                                }
                            })
                    );
                }}
            >
                {({ values, handleSubmit, setFieldValue, errors, touched }) => (
                    <form onSubmit={handleSubmit} style={{ padding: '20px 0' }}>
                        <div style={{ marginBottom: '24px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#374151' }}>
                                Anniversary Date
                            </label>
                            <DatePicker
                                value={values.anniversaryDate}
                                onChange={(date) => setFieldValue('anniversaryDate', date)}
                                style={{ width: '100%', height: '45px', borderRadius: '8px' }}
                                placeholder="Select Anniversary Date"
                                format="DD-MM-YYYY"
                            />
                            {errors.anniversaryDate && touched.anniversaryDate && (
                                <div style={{ color: '#ef4444', fontSize: '12px', marginTop: '4px' }}>
                                    {errors.anniversaryDate}
                                </div>
                            )}
                        </div>

                        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '30px' }}>
                            <button
                                type="button"
                                onClick={Isclose}
                                style={{
                                    padding: '10px 24px',
                                    borderRadius: '8px',
                                    border: '1px solid #e5e7eb',
                                    background: 'white',
                                    cursor: 'pointer',
                                    fontWeight: '500'
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                disabled={isLoading}
                                style={{
                                    padding: '10px 24px',
                                    borderRadius: '8px',
                                    border: 'none',
                                    background: '#2e37a4',
                                    color: 'white',
                                    cursor: 'pointer',
                                    fontWeight: '500',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    opacity: isLoading ? 0.7 : 1
                                }}
                            >
                                {isLoading && <Spin size="small" />}
                                Update Date
                            </button>
                        </div>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

AnniversaryModel.propTypes = {
    IsOpen: PropTypes.object,
    Isclose: PropTypes.func,
    customerData: PropTypes.object,
    confirmationDetails: PropTypes.object,
};

export default AnniversaryModel;
